import React from 'react';
import ReactDOM from 'react-dom';
import Component from './Component';

export default class Number extends Component {

	static rules = {
		numericality: {
			message: 'Hodnota musí být číslo!'
		}
	};

	getValue() {
		let value = ReactDOM.findDOMNode(this).value;
		if (value.length == 0) {
			return;
		}
		return value.replace(',', '.');
	}

	handleChange(e) {
		if (this.props.onChange) {
			this.props.onChange(this.getValue())
		}
	}

	handleBlur(e) {
		if (this.props.onBlur) {
			this.props.onBlur(this.getValue())
		}
	}

	render() {

		const props = {
			autoFocus: this.props.autoFocus,
			className: this.props.className,
			disabled: this.props.disabled,
			maxLength: this.props.maxLength,
			minLength: this.props.minLength,
			name: this.props.name,
			placeholder: this.props.placeholder,
			readOnly: this.props.readOnly,
			required: this.props.required,
			min: this.props.min,
			max: this.props.max,
			size: this.props.size,
			start: this.props.start,
			step: this.props.step,
			style: this.props.style,
			tabIndex: this.props.tabIndex,
			title: this.props.title,
			type: this.props.type
		};

		let value = typeof this.props.value != 'undefined' && this.props.value != null ? this.props.value.toString() : '';
		//value = value.replace('.', ',');
		return (
			<input type="number"
				   ref="input"
					{...props}
					value={value}
				   onChange={(e) => this.handleChange(e)}
				   onBlur={(e) => this.handleBlur(e)}
			/>
		)
	}
}


// WEBPACK FOOTER //
// ./src/reactis/reactis-inputs/NumberBase.js